export const PHONE_VALIDATOR = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/

export const cleanPhone = (dirtyPhone: string): string =>
  dirtyPhone.replace(/[\s.-]/g, "")
